import {
  Dialog,
  DialogActions,
  DialogTitle,
  Button,
  DialogContent,
} from "@mui/material";
import { useTheme } from "@mui/system";

const ConfermaSalva = ({ open, setOpen, onConfirm }) => {
  const theme = useTheme();
  return (
    <Dialog
      open={open}
      sx={{
        "& .MuiDialog-container": {
          "& .MuiPaper-root": {
            width: "100%",
            maxWidth: "400px", // Set your width here
            backgroundColor:
              // fallback to light if theme is not available
              typeof theme !== "undefined" && theme.palette.mode === "dark"
                ? "#1B2635"
                : "#F7F9FC",
          },
        },
      }}
    >
      <DialogTitle>Salva preventivo</DialogTitle>
      <DialogContent>Sei sicuro di voler salvare il preventivo?</DialogContent>
      <DialogActions>
        <Button
          onClick={() => setOpen(false)}
          color="primary"
          sx={{ marginRight: "8px" }}
        >
          Annulla
        </Button>
        <Button
          onClick={onConfirm}
          variant="contained"
          sx={{ marginRight: "8px" }}
        >
          Salva
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default ConfermaSalva;
